import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../styles/external/App.css';
import Modal from '../../components/external/Modal';
import { useEnvValue } from '../../config/env';

export default function TokenAutenticacao() {
  const API_BASE_URL = useEnvValue('REACT_APP_URL_API');
  const [token, setToken] = useState(['', '', '', '', '', '']);
  const [authToken, setAuthToken] = useState('');
  const [cpf, setCpf] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [modalData, setModalData] = useState({ show: false, title: '', message: '' });
  const [tokenIncompleto, setTokenIncompleto] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('jwt');
    const storedCpf = localStorage.getItem('cpf');
    const storedNascimento = localStorage.getItem('dataNascimento');

    if (storedToken && storedCpf && storedNascimento) {
      setAuthToken(storedToken);
      setCpf(storedCpf);
      setDataNascimento(storedNascimento);
    } else {
      setModalData({
        show: true,
        title: 'Erro de autenticação',
        message: 'Informações de autenticação ausentes. Redirecionando...'
      });
      setTimeout(() => navigate('/cadastro'), 3000);
    }
  }, []);

  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const novoToken = [...token];
    novoToken[index] = value;
    setToken(novoToken);
    setTokenIncompleto(false);

    if (value && index < 5) {
      const nextInput = document.getElementById(`token-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (token.some((char) => char === '')) {
      setTokenIncompleto(true);
      return;
    }

    const tokenDigitado = token.join('');

    try {
      const csrfRes = await axios.get(`${API_BASE_URL}/csrf/token`, {
        withCredentials: true,
      });

      const csrfToken = csrfRes.data?.csrfToken;

      const resValidaToken = await axios.post(
        `${API_BASE_URL}/notas/validar-token`,
        { cpf, dataNascimento, token: tokenDigitado },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'X-CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );

      localStorage.setItem('uuid', resValidaToken.data.uuid);
      localStorage.setItem('tokenValido', tokenDigitado);

      navigate('/senha');
    } catch (error) {
      const mensagemErro = error.response?.data?.message || 'Token inválido ou expirado. Tente novamente.';
      console.error('Erro ao validar token:', mensagemErro);

      setModalData({
        show: true,
        title: 'Token inválido',
        message: mensagemErro
      });
    }
  };

  const isTokenCompleto = token.every((char) => char !== '');

  return (
    <div className="container">
      <Modal
        show={modalData.show}
        title={modalData.title}
        message={modalData.message}
        onClose={() => setModalData({ ...modalData, show: false })}
      />

      <div className="left">
        <h1>Token de Autenticação</h1>
        <p>
          Enviado para o celular com final (XX) XXXX-XX00. <br />
          Digite o token nos campos abaixo.
        </p>

        <form className="token-form" onSubmit={handleSubmit}>
          <div className="token-inputs">
            {token.map((valor, index) => (
              <input
                key={index}
                id={`token-input-${index}`}
                type="text"
                maxLength="1"
                className="token-box"
                value={valor}
                onChange={(e) => handleChange(index, e.target.value)}
              />
            ))}
          </div>

          {tokenIncompleto && (
            <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
              Preencha todos os campos do token.
            </div>
          )}

          <button
            type="submit"
            className="button"
            disabled={!isTokenCompleto}
            style={{
              marginTop: '15px',
              opacity: !isTokenCompleto ? 0.5 : 1,
              cursor: !isTokenCompleto ? 'not-allowed' : 'pointer'
            }}
          >
            Enviar
          </button>
        </form>
      </div>
    </div>
  );
}
